import React, { useState } from 'react';

export default function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', message: '', website: '' }); // website = honeypot
  const [status, setStatus] = useState({ sending: false, ok: null, error: '' });

  const onChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  async function onSubmit(e) {
    e.preventDefault();
    setStatus({ sending: true, ok: null, error: '' });

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json.error || 'Failed to send');

      setStatus({ sending: false, ok: true, error: '' });
      setForm({ name: '', email: '', message: '', website: '' });
    } catch (err) {
      setStatus({ sending: false, ok: false, error: err.message || 'Error' });
    }
  }

  return (
    <form onSubmit={onSubmit} className="contact-form" autoComplete="off" noValidate>
      <div className="row">
        <label>
          Your Name
          <input
            name="name"
            type="text"
            required
            maxLength={120}
            value={form.name}
            onChange={onChange}
            placeholder="Jane Doe"
          />
        </label>
      </div>
      <div className="row">
        <label>
          Email
          <input
            name="email"
            type="email"
            required
            maxLength={200}
            value={form.email}
            onChange={onChange}
            placeholder="you@example.com"
          />
        </label>
      </div>
      <div className="row">
        <label>
          Message
          <textarea
            name="message"
            required
            maxLength={5000}
            value={form.message}
            onChange={onChange}
            placeholder="How can we help?"
            rows={6}
          />
        </label>
      </div>

      {/* Honeypot field (keep hidden from humans) */}
      <div style={{ position: 'absolute', left: '-5000px', height: 0, overflow: 'hidden' }}>
        <label>
          Website
          <input
            name="website"
            type="text"
            value={form.website}
            onChange={onChange}
            tabIndex={-1}
            autoComplete="off"
          />
        </label>
      </div>

      <button disabled={status.sending} className="btn">
        {status.sending ? 'Sending…' : 'Send Message'}
      </button>

      {status.ok === true && <p className="ok">Thanks! We’ll get back to you soon.</p>}
      {status.ok === false && <p className="err">Error: {status.error}</p>}
    </form>
  );
}